import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { Link } from "react-scroll";

export default function DefiDropdown({showPopup}) {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button className="flex items-center border-b-2 border-white hover:border-sky-800 transition-all dark:hover:border-sky-500 dark:hover:border-b-2 mx-3 py-1 dark:border-b-2 dark:border-primary">
          About
          <ChevronDownIcon className="-mr-1 ml-2 h-5 w-5" aria-hidden="true" />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="w-[400px] h-[400px] absolute left-0 z-10 mt-2 origin-top-right rounded-md shadow-xl shadow-gray-400 dark:shadow-gray-700 bg-gray-200 dark:bg-gray-800/80 backdrop-blur-md">
          <div className="p-3 grid gap-3 md:grid-cols-2 h-full">
            <Link
              to="leads"
              smooth="true"
              spy="true"
              className=" bg-primary hover:bg-gray-800 transition-all rounded-md flex flex-col items-center justify-center p-2"
            >
              <h1 className="font-semibold text-lg mt-3 mb-1 text-center text-white dark:text-sky-400">
                Leads
              </h1>
              <p className="text-gray-300 text-sm text-center">
                Check out our GDSC UIT Leads from 2020 to present
              </p>
            </Link>
            <div className="grid gap-3 md:grid-rows-2">
            <Link
              to="coreteam"
              smooth="true"
              spy="true"
              className=" bg-primary cursor-pointer hover:bg-gray-800 transition-all rounded-md p-3"
            >
           
                <img
                  src="img\n-logo-design-png-5-2.png"
                  className="w-16"
                  alt=""
                />
                <h1 className="font-semibold mt-3 mb-1 text-white dark:text-sky-400 ">
                  Core Team
                </h1>
                <p className="text-gray-300 text-sm">
                  View core team of different tenures
                </p>
              </Link>

              <Link
              to="partners"
              smooth="true"
              spy="true"
              className=" bg-primary cursor-pointer hover:bg-gray-800 transition-all rounded-md p-3"
            >
             
                <h1 className="font-semibold mt-3 mb-1 text-white dark:text-sky-400">
                  Partners
                </h1>
                <p className="text-gray-300 text-sm">
                 Have a look at our partners
                </p>

            </Link>

            </div>

            
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
